<template>
  <ItineraryModal
    v-if="itinerary"
    :isOpen="isOpen"
    :tripTitle="config.hikeName || ''"
    :itinerary="itinerary"
    @close="isOpen = false"
  />
</template>

<script setup>
// Standalone mount of the shared Itinerary modal for the (server-rendered)
// hike overview page — read-only, built from the saved hike's HikeDay
// records via GraphQL rather than the planner's live Vuex store.
import { ref, onMounted } from 'vue'
import ItineraryModal from '../components/ItineraryModal.vue'
import graph_client from '../../utils/graphql/graph_client'
import { GetHikeItinerary } from '../../utils/graphql/hikes-graph'
import { buildItineraryFromHikeDays } from '../components/itinerary/buildItineraryFromHikeDays'

const config = window.itineraryOverviewConfig || {}
const isOpen = ref(false)
const itinerary = ref(null)

async function ensureLoaded() {
  if (itinerary.value || !config.hikeId) return
  const data = await graph_client.request(GetHikeItinerary, { id: config.hikeId })
  itinerary.value = buildItineraryFromHikeDays(data.hike.hikeDays)
}

onMounted(() => {
  // Exposed so the ERB "Itinerary" menu item can open the modal.
  window.openItineraryModal = async () => {
    await ensureLoaded()
    isOpen.value = true
  }
})
</script>
